import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import { changePhoneNumber } from 'utils/inputUtils'
import PredictionInputText from '../input/PredictionInputText.mobile'
import PredictionFormLabel from '../label/PredictionFormLabel.mobile'

interface IFProps {
  disabled: boolean
}

const FormItemPhoneNumber: FC<IFProps> = ({ disabled }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  return (
    <StyledWrapper>
      <PredictionFormLabel label="휴대폰 번호" />
      <PredictionInputText
        type="tel"
        disabled={disabled}
        minLength={12}
        maxLength={13}
        isErrors={!!errors.phoneNumber?.message}
        placeholder="010-0000-0000"
        {...register('phoneNumber', {
          onChange: changePhoneNumber,
        })}
      />
    </StyledWrapper>
  )
}

export default FormItemPhoneNumber

const StyledWrapper = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;

  > p {
    flex: 3;
  }
  > div {
    flex: 7;
  }
`
